import React from 'react';

const AddCardIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 8.5H13.5" stroke="#4EDF6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 16.5H8" stroke="#4EDF6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M10.5 16.5H14.5" stroke="#4EDF6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22 12.03V16.11C22 19.62 21.11 20.5 17.56 20.5H6.44C2.89 20.5 2 19.62 2 16.11V7.89C2 4.38 2.89 3.5 6.44 3.5H13.5" stroke="#4EDF6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.5 6.25H22" stroke="#4EDF6D" stroke-width="1.5" stroke-linecap="round" />
        <path d="M19.25 9V3.5" stroke="#4EDF6D" stroke-width="1.5" stroke-linecap="round" />
    </svg>

);

export default AddCardIcon; 